export const SET_ACTIVE_SIDEBAR_SECTION = 'SET_ACTIVE_SIDEBAR_SECTION';
export const SET_ACTIVE_SIDEBAR_ARTICLES = 'SET_ACTIVE_SIDEBAR_ARTICLES';
export const SET_ACTIVE_LIST_ARTICLES = 'SET_ACTIVE_LIST_ARTICLES';
export const SET_LISTS_TASKS = 'SET_LISTS_TASKS';
export const TOGGLE_SIDEBAR_COLLAPSED = 'TOGGLE_SIDEBAR_COLLAPSED';

export const setActiveSidebarSection = (section) => ({
  type: SET_ACTIVE_SIDEBAR_SECTION,
  section,
});

export const setActiveSidebarArticles = (section) => ({
  type: SET_ACTIVE_SIDEBAR_ARTICLES,
  section,
});

export const setActiveListArticles = (list) => ({
  type: SET_ACTIVE_LIST_ARTICLES,
  list,
});

export const setListsTasks = (lists) => ({
  type: SET_LISTS_TASKS,
  lists,
});

export const toggleSidebarCollapsed = () => ({
  type: TOGGLE_SIDEBAR_COLLAPSED,
});
